export default "__VITE_ASSET__BMp34xdX__"